<template>
  <div><h3>Pay</h3></div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Pay',
  mounted () {
    console.log('Pay');
  },
  methods: {
    
  }
}
</script>